import { lazy } from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

const Container = lazy(() => import("../../common/Container"));
const Expandables = lazy(() => import("../../components/Expandables"));
const MainBlock = lazy(() => import("../../components/MainBlock"));
const OurEthnos = lazy(() => import("../../components/OurEthnos"));
const Process = lazy(() => import("../../components/Process"));
const ContactBlock = lazy(() => import("../../components/Contact"));


const Home = () => {
  const isMobile = useIsMobile()
  
  return (
    <Container>
      <MainBlock/>
      {!isMobile ? <OurEthnos/> : null}
      <Process/>
      <Expandables/>
      {/* <ContactBlock/> */}
    </Container>
  );
};

export default Home;